import React from 'react';
import {
  Button,
  ContainerDimensionsContextProvider,
  Icon,

  Modal } from
'@therms/atalaya';
import { history } from '@src/App';
import { generatePath } from 'react-router-dom';
import { LOCATIONS_ROUTES } from '@src/modules/Locations/constants';
import ViewLocation from '@src/modules/Locations/components/ViewLocation';
import { MdOpenInNew } from 'react-icons/md';

interface ViewLocationModalProps {
  closeHandler: () => void;
  locationId: string;
}

function ViewLocationModal({
  closeHandler,
  locationId
}: ViewLocationModalProps) {
  return (
    <Modal
      closeHandler={closeHandler}
      escPressClose
      header={
      <div className="inline-flex items-center justify-between w-full">
          <span className="text-lg">Location</span>

          <Button
          className="cursor-pointer"
          onClick={() => {
            history.push(
              generatePath(LOCATIONS_ROUTES.VIEW_LOCATION, {
                locationId
              })
            );
            closeHandler();
          }}
          subtle
          variant="main">

            <Icon Icon={MdOpenInNew} size="sm" />
          </Button>
        </div>
      }
      width="xl">

      <ContainerDimensionsContextProvider>
        <ViewLocation locationId={locationId} />
      </ContainerDimensionsContextProvider>
    </Modal>);

}

export { ViewLocationModal };